import { loadQuery, type PreloadedQuery } from 'react-relay';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
// eslint-disable-next-line jira/import-whitelist
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
import consolidatedResourcesQuery, {
	type JiraResourceIntegration,
	type consolidatedResourcesQuery as ConsolidatedResourcesQueryType,
} from './__generated__/consolidatedResourcesQuery.graphql.ts';

const RESOURCES_INTEGRATION: Record<string, JiraResourceIntegration> = {
	ATTACHMENT: 'ATTACHMENT',
	LOOM: 'LOOM',
	CONFLUENCE: 'CONFLUENCE',
	WHITEBOARD: 'WHITEBOARD',
	GDRIVE: 'GDRIVE',
};

const getResourcesData = async (
	{ match }: RouterDataContext,
	_storeContext: ResourceStoreContext,
): Promise<PreloadedQuery<ConsolidatedResourcesQueryType, {}> | null> => {
	const issueKey = getIssueKey(match);
	const {
		tenantContext: { cloudId },
	} = _storeContext;

	if (!issueKey) {
		return null;
	}

	const consolidatedResourcesData = loadQuery<ConsolidatedResourcesQueryType>(
		getRelayEnvironment(),
		consolidatedResourcesQuery,
		{
			issueKey,
			cloudId,
			maxResults: 12,
			startAt: '',
			orderField: 'CREATED',
			orderDirection: 'DESC',
			filters: [
				{ integration: RESOURCES_INTEGRATION.CONFLUENCE },
				{ integration: RESOURCES_INTEGRATION.WHITEBOARD },
				{ integration: RESOURCES_INTEGRATION.LOOM },
				{ integration: RESOURCES_INTEGRATION.ATTACHMENT, types: [] },
			],
			totalCount: 0,
			totalLinks: 0,
			next: '',
			isLast: false,
			targetPageNumber: 1,
			currentPageNumber: 1,
		},
	);
	return consolidatedResourcesData;
};

export default getResourcesData;
